import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  NOTIFICATIONS,
  NOTIFY_DEL_RESPONSE,
  NOTIFY_ADD_EDT_RESPONSE,
  NOTIFY_REPLAY_RESPONSE,
  LOADER_IDENTIFIER,
  ALL_ROLES,
} = STATE_IDENTIFIER;

export default {
  [NOTIFICATIONS]: {
    pageTotalNumber: -1,
    messages: [],
  },
  [NOTIFY_DEL_RESPONSE]: IResponseState.PENDING,
  [NOTIFY_ADD_EDT_RESPONSE]: IResponseState.PENDING,
  [NOTIFY_REPLAY_RESPONSE]: IResponseState.PENDING,
  [LOADER_IDENTIFIER]: false,
  [ALL_ROLES]: [],
};
